import { apiClient } from '../apiClient';
import {
  OidcLoginResponseDto,
  AuthResponseDto,
  UserDto,
} from '@shared/contracts';

export const authApi = {
  initiateLogtoLogin: (redirectUri?: string): Promise<OidcLoginResponseDto> => {
    return apiClient.get<OidcLoginResponseDto>('/auth/login', {
      params: { redirect_uri: redirectUri },
    });
  },

  handleLogtoCallback: (code: string, state: string, redirectUri?: string): Promise<AuthResponseDto> => {
    return apiClient.get<AuthResponseDto>('/auth/callback', {
      params: { code, state, redirect_uri: redirectUri },
    });
  },

  getMe: (): Promise<UserDto> => {
    return apiClient.get<UserDto>('/auth/me');
  },

  setActiveModel: (providerId: string): Promise<UserDto> => {
    return apiClient.post<UserDto>('/auth/active-model', { providerId });
  },

  logout: (): Promise<{ logoutUrl: string }> => {
    return apiClient.get<{ logoutUrl: string }>('/auth/logout');
  },

  getUsers: (): Promise<UserDto[]> => {
    return apiClient.get<UserDto[]>('/auth/users');
  },

  updateUserRole: (id: string, role: string): Promise<UserDto> => {
    return apiClient.patch<UserDto>(`/auth/users/${id}/role`, { role });
  },

  register: (data: { email: string; password?: string; role: string }): Promise<UserDto> => {
    return apiClient.post<UserDto>('/auth/users', data);
  },
};
